import { render, staticRenderFns } from "./column_not_updated.vue?vue&type=template&id=6573d7a6&scoped=true&"
import script from "./column_not_updated.vue?vue&type=script&lang=js&"
export * from "./column_not_updated.vue?vue&type=script&lang=js&"
import style0 from "./column_not_updated.vue?vue&type=style&index=0&id=6573d7a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573d7a6",
  null
  
)

export default component.exports